module.exports = __webpack_public_path__ + "static/media/Notice_1_to_607.a737ff29.pdf";